<div cdkDropList (cdkDropListDropped)="drop($event)">
    <ng-template #defaultTemplate></ng-template>
    @for (item of sortedItems; track item; let i = $index) {
        <div class="draggable" cdkDrag>
            <ng-container *ngTemplateOutlet="itemRef || defaultTemplate; context:{$implicit: item, index: i}"/>
        </div>
    }
</div>
